import * as yup from 'yup';
import { HeroBadge } from '@web/components';

export const component = HeroBadge;

export const schema = yup
  .object({
    badgeStyle: yup.string(),
    primaryText: yup.string().required(),
    subText: yup.string(),
    boldSubText: yup.bool(),
    curvedTextTop: yup.string(),
    curvedTextBottom: yup.string(),
  })
  .transform(value => ({
    badgeStyle: value.badge_style || undefined,
    primaryText: value.primary_text,
    subText: value.sub_text,
    boldSubText: value.bold_sub_text,
    curvedTextTop: value.curved_text_top,
    curvedTextBottom: value.curved_text_bottom,
  }));
